export default "__VITE_ASSET__cfc86dd0__"